import React from 'react';
import { YNABBudget } from '../types/ynab';
import './BudgetSelector.css';

interface BudgetSelectorProps {
  budgets: YNABBudget[];
  selectedBudget: YNABBudget | null;
  onBudgetSelect: (budget: YNABBudget) => void;
}

export const BudgetSelector: React.FC<BudgetSelectorProps> = ({
  budgets,
  selectedBudget,
  onBudgetSelect,
}) => {
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const budgetId = event.target.value;
    const budget = budgets.find(b => b.id === budgetId);
    if (budget) {
      onBudgetSelect(budget);
    }
  };

  if (budgets.length === 0) {
    return (
      <div className="budget-selector">
        <p>No budgets found</p>
      </div>
    );
  }

  if (budgets.length === 1) {
    return (
      <div className="budget-selector">
        <h3>Budget: {budgets[0].name}</h3>
      </div>
    );
  }

  return (
    <div className="budget-selector">
      <label htmlFor="budget-select">Select Budget:</label>
      <select
        id="budget-select"
        value={selectedBudget?.id || ''}
        onChange={handleSelectChange}
        className="budget-select"
      >
        <option value="">Choose a budget...</option>
        {budgets.map(budget => (
          <option key={budget.id} value={budget.id}>
            {budget.name}
          </option>
        ))}
      </select>
    </div>
  );
};
